import { styled } from 'baseui'
import { SHAPE, KIND } from 'baseui/button'

import Icons from '../../Icons'
import { useEffect, useState } from 'react'
import { usePixelManipulationEditorContext } from '@/scenes/engine'

import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import useAppContext from '@/hooks/useAppContext'
import { useSelector } from 'react-redux'
import { selectDisableEditorState } from '@/store/slices/editor/selector'
const Container = styled('div', props => ({
  display: 'flex',
  alignItems: 'center',
}))

function RemoveHistory() {
  const editor = usePixelManipulationEditorContext().editor
  const disableEditorState = useSelector(selectDisableEditorState)

  const isDisabled = disableEditorState.history === 'disabled'

  const [historyStatus, setHistoryStatus] = useState({ hasUndo: false, hasRedo: false })
  useEffect(() => {
    const handleHistoryChange = (data: any) => {
      setHistoryStatus({ ...historyStatus, hasUndo: data.hasUndo, hasRedo: data.hasRedo })
    }
    if (editor) {
      editor.on('remove-history:changed', handleHistoryChange)
    }
    return () => {
      if (editor) {
        editor.off('remove-history:changed', handleHistoryChange)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor])

  const { toolType } = useAppContext()

  return (
    <>
      {toolType === 'Enhance' ? (
        <></>
      ) : (
        <Container>
          <ButtonCustom
            style={{
              borderRadius: '50%',
              pointerEvents: historyStatus.hasUndo && isDisabled ? 'none' : 'auto',
            }}
            onClick={() => {
              editor.undo()
            }}
            type={SizeButton.STANDARD}
            kind={KIND.minimal}
            shape={SHAPE.square}
            tooltip={{
              content: 'Undo',
              placement: 'bottom',
            }}
          >
            <Icons.Undo size={24} disabled={!historyStatus.hasUndo || isDisabled} />
          </ButtonCustom>
          <ButtonCustom
            style={{
              borderRadius: '50%',
              pointerEvents: historyStatus.hasRedo && !isDisabled ? 'auto' : 'none',
            }}
            onClick={() => {
              editor.redo()
            }}
            type={SizeButton.STANDARD}
            kind={KIND.minimal}
            shape={SHAPE.square}
            tooltip={{
              content: 'Redo',
              placement: 'bottom',
            }}
          >
            <Icons.Redo size={24} disabled={!historyStatus.hasRedo || isDisabled} />
          </ButtonCustom>
        </Container>
      )}
    </>
  )
}
export default RemoveHistory
